export default function orders(state = [], action) {
  return state;
}


// WEBPACK FOOTER //
// ./src/redux/orders/reducer.js